__turbopack_context__.v({
  "bottomBar": "vAqsWa_bottomBar",
  "contact": "vAqsWa_contact",
  "desktop": "vAqsWa_desktop",
  "footer": "vAqsWa_footer",
  "info": "vAqsWa_info",
  "infoItems": "vAqsWa_infoItems",
  "link": "vAqsWa_link",
  "linkContainer": "vAqsWa_linkContainer",
  "links": "vAqsWa_links",
  "linksAndNewsletter": "vAqsWa_linksAndNewsletter",
  "locales": "vAqsWa_locales",
  "locationItems": "vAqsWa_locationItems",
  "locationTitle": "vAqsWa_locationTitle",
  "locations": "vAqsWa_locations",
  "logoLink": "vAqsWa_logoLink",
  "mainContent": "vAqsWa_mainContent",
  "mobile": "vAqsWa_mobile",
  "navItem": "vAqsWa_navItem",
  "navItems": "vAqsWa_navItems",
  "navLink": "vAqsWa_navLink",
  "newsletter": "vAqsWa_newsletter",
  "socialButton": "vAqsWa_socialButton",
  "socialItem": "vAqsWa_socialItem",
  "socialItemIcon": "vAqsWa_socialItemIcon",
  "socialLink": "vAqsWa_socialLink",
  "socialLinks": "vAqsWa_socialLinks",
  "title": "vAqsWa_title",
  "tooltipContent": "vAqsWa_tooltipContent",
  "tooltipContentContainer": "vAqsWa_tooltipContentContainer",
  "wechatTooltipContent": "vAqsWa_wechatTooltipContent",
});
